import { Dispatch, SetStateAction, useState } from "react";
import TextField from "@mui/material/TextField";
import CloseIcon from "@mui/icons-material/Close";
import { Modal, Button } from "@mui/material";
import { useAddExpertiseMutation } from "../service/cms";
import { showError, showToast } from "../constants/toasts";

interface AddCategoryModalProps {
  open: boolean;
  onClose: () => void;
  setOpen: Dispatch<SetStateAction<boolean>>;
  getExpertiseApi: () => void;
}

export default function AddExpertise({
  open,
  onClose,
  setOpen,
  getExpertiseApi,
}: AddCategoryModalProps) {
  const [addExpertise] = useAddExpertiseMutation();

  const [error, setError] = useState(false);
  const [name, setName] = useState("");
  const [loading, setLoading] = useState(false);

  const handleAddExpertise = async () => {
    setError(true);
    if (name?.trim() === "") {
      showError("Interest is required");
      return;
    }

    setLoading(true);
    try {
      let response = await addExpertise({ name: name }).unwrap();

      if (response?.status === 200) {
        setError(false);
        setOpen(false);
        showToast("Expertise added successfully");
        getExpertiseApi();
        setName("");
      }
    } catch (error: any) {
      showError(error?.data?.message || "");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal className="modal addCategory_modal" open={open} onClose={onClose}>
      <div className="modal-dialog">
        <div className="modal-body">
          <div className="modal_title text_center mb_30">
            <h2>Add Expertise</h2>
            <div
              className="btn-close"
              role="button"
              tabIndex={0}
              onClick={() => {
                setName("");
                setOpen(false);
                setError(false);
              }}
            >
              <CloseIcon />
            </div>
          </div>
          <form
            className="form"
            onSubmit={(e) => {
              e.preventDefault();
              handleAddExpertise();
            }}
          >
            <div className="control_group">
              <label htmlFor="expertiseName">Expertise Name</label>
              <TextField
                id="expertiseName"
                aria-labelledby="expertiseNameLabel"
                placeholder="Enter Expertise Name"
                fullWidth
                hiddenLabel
                value={name}
                onChange={(e) => {
                  if (e.target.value === " " || e.target.value === ".") {
                  } else {
                    setName(e.target.value);
                  }
                }}
                inputProps={{
                  'aria-label': 'Expertise Name',
                }}
              />
            </div>
            <div className="footer_btn_flex">
              <Button className="btn btn_primary" type="submit" role="button" tabIndex={0}>
                Submit
              </Button>
            </div>
          </form>
        </div>
      </div>
    </Modal>
  );
}
